module.exports = __webpack_public_path__ + "static/img/arinkel-2.0e7fbf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/arinkel-2.jpg
// module id = okeX
// module chunks = 1